import type { LvWheelConfig } from '@bcf-vanilla-ts-v1-configurators/tokens/lottery/types';
import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// biome-ignore lint/style/useNamingConvention: must be that way
export const IS_LOTTERY_ELEMENTS_TYPE: DiToken<boolean> = new DiToken<boolean>('IS_LOTTERY_ELEMENTS_TYPE', {
  factory: () => false
});

// biome-ignore lint/style/useNamingConvention: must be that way
export const DISABLE_LOTTERY_DELAY_OF_PRIZE_DRAWN_SIGNAL: DiToken<boolean> = new DiToken<boolean>(
  'DISABLE_LOTTERY_DELAY_OF_PRIZE_DRAWN_SIGNAL',
  {
    factory: () => false
  }
);

// biome-ignore lint/style/useNamingConvention: must be that way
export const LOTTERY_BRAND_NAME: DiToken<string> = new DiToken<string>('LOTTERY_BRAND_NAME', {
  factory: () => `Lottery`
});

// biome-ignore lint/style/useNamingConvention: must be that way
export const LOTTERY_ASSETS_URL: DiToken<string> = new DiToken<string>('LOTTERY_ASSETS_URL');

// biome-ignore lint/style/useNamingConvention: must be that way
export const LV_WHEEL_CONFIG: DiToken<LvWheelConfig> = new DiToken<LvWheelConfig>('LV_WHEEL_CONFIG', {
  factory: () => ({
    assetsUrl: 'https://lvbet-static.com/images/other/lv-wheel-v2',
    assetVariant: 'en'
  })
});
